import { userManager } from './userService';

const SilentSigninOidc = () => {
    userManager.signinSilentCallback().then((user) => { });
    return <></>;
}

export default SilentSigninOidc;